import React from 'react';
import DownloadSection from '../components/DownloadSection';
import FAQSection from '../components/FAQSection';


const FAQ = () => {
    return (
        <div>
            <FAQSection />
            <DownloadSection />
            {/* Other sections of Beranda can be added here */}
        </div>
    );
};

export default FAQ;